module.exports = __webpack_public_path__ + "static/media/usuarios_roles_y_permisos.1505348c.svg";